<template>
  <template v-if="referenceModel">
    <sup>
      <a
        :id="`p-ref${referenceModel.elements.referenceOrderNumber.value}`"
        @click="scrollToReference(referenceModel.elements.referenceOrderNumber.value)"
      >
        {{ text }}
      </a>
    </sup>
  </template>

  <template v-else-if="formattedText">
    <ContentFormattedText :model="formattedText" :text="props.text" />
  </template>

  <template v-else-if="internalLink">
    <InternalLink :model="internalLink" :text="props.text" />
  </template>

  <template v-else>
    <MyLink v-if="href.startsWith('http') || isEmail" :to="href" :target="linkTarget">
      {{ text }}
    </MyLink>
    <MyLink v-else-if="href.startsWith('/')" :to="href">
      {{ text }}
    </MyLink>
    <a v-else href="#" data-bs-toggle="tooltip" @click.prevent="scrollToElement(href)">
      {{ text }}
    </a>
  </template>
</template>
<script lang="ts" setup>
import type { IContentItem } from '@kontent-ai/delivery-sdk'
import type { FormattedTextModel, InternalLinkModel } from '~/models'
const { scrollToElement } = useSmoothScroll()
const siteStore = useSiteStore()
const pageStore = usePageStore()
const props = defineProps<{
  text: string,
  value: any,
}>()

const href = ref<string>('') // final href
const isEmail = ref<boolean>(false)
const itemId = ref<string>('')
const referenceModel = ref<IContentItem | null>(null)
const formattedText = ref<FormattedTextModel | null>(null)
const internalLink = ref<InternalLinkModel | null>(null)
const { locale } = useI18n()
if (props.value) {
  if (props.value.reference?._type === 'reference') {
    itemId.value = props.value.reference._ref

    if (itemId.value) {
      const item = pageStore.getPageReferenceById(itemId.value)
      if (item && 'isPageReference' in item) {
        referenceModel.value = item as IContentItem
      } else {
        const formatted = siteStore.getFormattedText(itemId.value)
        if (formatted) {
          formattedText.value = formatted as FormattedTextModel
        } else {
          const isLink = siteStore.getInternalLink(itemId.value)        
          if (isLink) {
            internalLink.value = isLink as InternalLinkModel
          } else {
            href.value = siteStore.getUrlByItemId(itemId.value, locale.value)
            if (!href.value) href.value = itemId.value
          }
        }
      }
    }
  } else if (
    'data-email-address' in props.value ||
    'data-phone-number' in props.value ||
    'data-asset-id' in props.value
  ) {
    isEmail.value = true
    href.value = props.value.href
  } else {
    href.value = props.value.href
  }
}

const linkTarget = computed(() => getLinkTarget(isEmail.value, href.value))

const scrollToReference = async (order: number) => {
  if (!pageStore.referenceListVisible) {
    pageStore.referenceListVisible = true
    await nextTick()
  }
  scrollToElement(`ref${order}`)
}
</script>
